module.exports = __webpack_public_path__ + "img/aeroland-payment-image-01.76b1797b.png";